import api from 'api';
import { VouchersRequestData, VouchersResponseData } from './types';

export const createVouchers = async (voucherData: VouchersRequestData) => {
  const { data } = await api.post<VouchersResponseData>(
    '/vouchers',
    voucherData
  );

  return data;
};
